import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetplanos", data.data);
  dispatch("ActionSetPagination", data.meta);
  return data.data;
};

export const ActionGetPeriodic = async ({ dispatch }, payload) => {
  const response = await services.planos.get_all_periodic(payload);
  return response.data;
};

export const ActionSavePeriodic = async ({ dispatch }, payload) => {
  if (payload.id) {
    return dispatch("ActionUpdatePeriodic", payload);
  }

  return dispatch("ActionStorePeriodic", payload);
};

export const ActionStorePeriodic = async (store, payload) => {
  const response = await services.planos.store_periodic(payload);
  return response.data;
};

export const ActionUpdatePeriodic = async (store, payload) => {
  const response = await services.planos.update_periodic(
    { id: payload.id },
    payload
  );
  return response.data;
};

export const ActionDeletePeriodic = async (store, id) => {
  const response = await services.planos.delete_periodic({ id });
  return response.data;
};

export const ActionFind = async (store, search) => {
  let planos = {
    data: [],
    meta: {},
  };

  await services.planos.get_all(search).then((res) => {
    planos = res.data;
  });
  return planos;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.planos.show({ id: id }).then((res) => {
    dispatch("ActionSetplano", res.data.planoexitos);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.planos.store(payload).then((res) => {
    commit(types.SET_plano, res.data.planoexitos);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.planos.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_plano, res.data.planoexitos);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.planos.delete({ id: id }).then(() => {
    commit(types.SET_plano, null);
  });
};

export const ActionSetplanos = ({ commit }, payload) => {
  commit(types.SET_planoS, payload);
};

export const ActionSetplano = ({ commit }, payload) => {
  commit(types.SET_plano, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewplano = ({ commit }) => {
  commit(types.SET_plano, {});
};
